import React from 'react';

export const useAsyncEffect = (effect: () => Promise<void>, deps: React.DependencyList): void => {
  React.useEffect((): void => {
    void effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
